(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-faq-section"] && !window.DesignMode) return;
  try {
    
let header = document.querySelectorAll(".accordion-header");

header.forEach(
header => {
  header.addEventListener("click", function (e) {
    let accordion = document.querySelectorAll(".accordion");
    let parentElm = header.parentElement;
    let siblings = this.nextElementSibling;

    accordion.forEach(element => {
      element.children[1].style.maxHeight = null;
    });

    parentElm.classList.toggle("active");
    if (parentElm.classList.contains("active")) {
      accordion.forEach(element => {
        element.classList.remove("active");
      });

      parentElm.classList.toggle("active");
      if (siblings.style.maxHeight) {
        siblings.style.maxHeight = null;
      } else {
        siblings.style.maxHeight = siblings.scrollHeight + "px";
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
